import { render, staticRenderFns } from "./AppliedCascadeAccessView.vue?vue&type=template&id=6815ea40"
import script from "./AppliedCascadeAccessView.vue?vue&type=script&lang=js"
export * from "./AppliedCascadeAccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports